/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";

import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";
import { SimpleSelectInput, SimpleTextInput } from "./index";
import Loader from "../../ui/Loader";
import Switcher from "../../ui/Switcher";
import validatehoc from "../Validator";
import { URL } from "../../../constants";

class PageOrUrlPicker extends Component {
	constructor(props) {
		super(props);
		this.appKey = parseAppKey();
		this.state = {
			type: this.initialSetup(props),
			minimizePlaceholder: false,
			experienceOptions: [],
			pageOptions: [],
			loadingPages: false,
			showAdvanced: false,
		};
	}

	initialSetup = props => {
		let { value } = props.fieldState;
		if (value) {
			if (value.experienceId) {
				GetItem(`/experiences/${value.experienceId}/pages`).then(data => {
					let pageOptions = [];
					data.data.forEach(page => {
						pageOptions.push({ key: page.id, value: page.id, label: page.name });
					});
					this.setState({ pageOptions, loadingPages: false });
				});
				return "page";
			} else if (value.url) {
				return "url";
			}
		}
		if (props.isRequired) {
			return "page";
		}
		return "none";
	};

	componentDidMount() {
		if (this.props) {
			GetItem(`/apps/${this.appKey}/experiences`).then(data => {
				let experienceOptions = [];
				data.data.forEach(experience => {
					experienceOptions.push({ key: experience.id, value: experience.id, label: experience.name });
				});
				this.setState({ experienceOptions });
			});
		}
	}

	onFocus = () => {
		this.setState({
			minimizePlaceholder: true,
		});
	};

	onBlur = value => {
		if (!value || value.length < 1) {
			this.setState({
				minimizePlaceholder: false,
			});
		}
	};

	changeExperience = e => {
		let value = e.target.value;
		this.props.fieldApi.setValue(Object.assign({}, this.props.fieldState.value, { experienceId: value }));
		this.props.fieldApi.setTouched(true);
		if (value !== "") {
			this.setState({ loadingPages: true });
			GetItem(`/experiences/${value}/pages`).then(data => {
				let pageOptions = [];
				data.data.forEach(page => {
					pageOptions.push({ key: page.id, value: page.id, label: page.name });
				});

				this.setState({ pageOptions, loadingPages: false });
			});
		} else {
			this.setState({ pageOptions: [] });
		}
	};

	changePage = e => {
		let value = e.target.value;
		this.props.fieldApi.setValue(Object.assign({}, this.props.fieldState.value, { pageId: value }));
		this.props.fieldApi.setTouched(true);
	};

	changeUrl = e => {
		let value = e.target.value;
		this.props.fieldApi.setValue(Object.assign({}, this.props.fieldState.value, { url: value }));
		this.props.fieldApi.setTouched(true);
	};

	changeType = (index, option) => {
		this.setState({ type: option.value });
		this.props.fieldApi.setValue({});
		this.props.fieldApi.setTouched(true);
	};

	render() {
		const { isRequired, placeholder, fieldState } = this.props;
		const { value } = fieldState;
		const { experienceOptions, pageOptions } = this.state;

		const switcherOptions = [
			{ label: "None", value: "none" },
			{ label: "Page", value: "page" },
			{ label: "Url", value: "url" },
		];
		if (isRequired) {
			switcherOptions.shift();
		}

		return (
			<Fragment>
				<div className="input-wrap focus p-0">
					<div className="placeholder">
						{isRequired && <span className="isrequired-label">*</span>}
						{placeholder}
					</div>
					<Switcher initialValue={this.state.type} options={switcherOptions} onSelect={this.changeType} />
					<div className="switcher-well">
						{this.state.type === "none" && <div>{"Don't link to anything"}</div>}
						{this.state.type === "page" && (
							<div>
								{experienceOptions.length > 0 && (
									<SimpleSelectInput
										field="experienceId"
										id="experienceId"
										placeholder="Experience"
										values={experienceOptions}
										value={value.experienceId ? value.experienceId : ""}
										onChange={e => {
											this.changeExperience(e);
										}}
									/>
								)}
								{this.state.loadingPages && <Loader />}
								{pageOptions.length > 0 && !this.state.loadingPages ? (
									<SimpleSelectInput
										field="pageId"
										id="pageId"
										placeholder="Page"
										value={value.pageId ? value.pageId : ""}
										values={pageOptions}
										onChange={e => {
											this.changePage(e);
										}}
									/>
								) : (
									!this.state.loadingPages && <div className="note">No Pages To Display</div>
								)}
							</div>
						)}
						{this.state.type === "url" && (
							<div>
								<SimpleTextInput
									field="url"
									id="url"
									placeholder="Url"
									isRequired
									validationRegex={URL}
									value={value.url ? value.url : ""}
									onChange={e => {
										this.changeUrl(e);
									}}
								/>
							</div>
						)}
					</div>
				</div>
			</Fragment>
		);
	}
}

PageOrUrlPicker.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	values: PropTypes.array,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	defaultEnabled: PropTypes.bool,
	fieldState: PropTypes.object,
	appKey: PropTypes.string,
	fieldApi: PropTypes.object,
	collectionPrefix: PropTypes.string,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <PageOrUrlPicker fieldState={fieldState} {...props} />),
	"string"
);

export default Wrapper;
